import { useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';
import B2CoreOAuthCallback from '@/pages/Auth/B2CoreOAuthCallback';
import B2CoreOAuthStart from '@/pages/Auth/B2CoreOAuthStart';
import Login from '@/pages/Auth/Login';
import Register from '@/pages/Auth/Register';
import EmbedRoute from './components/EmbedRoute';
import { EmptyAccounts } from './components/emptyAccounts.tsx';
import Fallback from './components/Fallback';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Spinner from './components/Spinner';
import useValidate from './hooks/useValidate';
import { AccountsLayout } from './pages/Accounts/Accounts.tsx';
import B2CoreEmbed from './pages/Embed/B2CoreEmbed.tsx';
import { IbEmbedPage } from './pages/Embed/IbEmbedPage.tsx';
import { IbDeskPage } from './pages/IbDesk/IbDeskPage.tsx';
import NotFound from './pages/NotFound/NotFound.tsx';
import { CertificatesLayout } from './pages/Services/Certificates/CertificatesLayout.tsx';
import Services from './pages/Services/Services.tsx';
import SocialTradingHandler from './pages/Services/SocialTrading/SocialTradingHandler.tsx';
import { TradingIdeas } from './pages/Services/TradingIdeas/TradingIdeas.tsx';
import Sessions from './pages/Sessions/Sessions.tsx';

const AppRoutes = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { i18n } = useTranslation();

  useValidate(setIsLoading);

  useEffect(() => {
    document.documentElement.dir = i18n.dir(i18n.language);
  }, [i18n, i18n.language]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Layout>
      <ErrorBoundary FallbackComponent={Fallback}>
        <Routes>
          <Route path="/">
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/oauth/start" element={<B2CoreOAuthStart />} />
              <Route path="/oauth/callback" element={<B2CoreOAuthCallback />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route index element={<Services />} />
              <Route path="/sessions" element={<Sessions />} />
              <Route path="/ib-data/*" element={<IbDeskPage />} />
              <Route path="/services/certificates" element={<CertificatesLayout />} />
              <Route path="/services/trading-ideas" element={<TradingIdeas />} />
              <Route path="/accounts" element={<AccountsLayout />} />
            </Route>
            <Route path="/embed">
              <Route index element={<B2CoreEmbed />} />
              <Route element={<EmbedRoute />}>
                <Route path="ib-desk/*" element={<IbEmbedPage />} />
              </Route>
            </Route>
            <Route path="/services/social-trading" element={<SocialTradingHandler />} />
            <Route path="/services/empty-accounts" element={<EmptyAccounts />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </ErrorBoundary>
    </Layout>
  );
};

export default AppRoutes;
